<template>
  <div id="the-good">
    <b-container class="the-good-container">
      <div class="gitg-logo-container" v-if="global.screenWidth > 992">
        <img
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/efdot/The-Good-Slider/The-Good-Logo.jpg')
          "
        />
      </div>
      <div class="good-content">
        <div class="header-align">
          <Header title="The Good" :alignBarStart="global.screenWidth > 992" />
        </div>
        <img
          v-if="global.screenWidth <= 992"
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/efdot/The-Good-Slider/The-Good-Logo.jpg')
          "
        />

        <p>
          Bring Change to Mind (BC2M) is a nonprofit organization working to end
          the stigma and discrimination surrounding mental illness. Through
          multimedia public service announcements, they curate storytelling
          movements and develop evidence-based youth programs to encourage a
          diverse cultural conversation around mental health.

          <br />
        </p>
        <ImageGallery
          style="margin-top: 40px; margin-bottom: 40px"
          :data="[
            require('@/assets/images/galleries/efdot/The-Good-Slider/mental-health-01.jpg'),
            require('@/assets/images/galleries/efdot/The-Good-Slider/mental-health-02.jpg'),
            require('@/assets/images/galleries/efdot/The-Good-Slider/mental-health-03.jpg'),
          ]"
          :idString="'thegood'"
        />
        <p>
          BC2M activates and empowers others to join the fight so everyone can
          thrive in a stigma-free world. To learn more about Bring Change to
          Mind, please visit
          <a href="https://www.bringchange2mind.org" target="_blank"
            >www.bringchange2mind.org.</a
          >
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import { mapState } from "vuex";
export default {
  name: "TheGood",
  components: {
    ImageGallery,
    Header,
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-good {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-good-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    @media (max-width: 1050px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .gitg-logo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    height: 100%;
    @media (max-width: 1050px) {
      align-items: center;
    }
  }
  .header-align {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;
    height: 100px;
    width: auto;
    @media (max-width: 1050px) {
      justify-content: center;
      margin-bottom: 0;
    }
  }
  .gitg-logo {
    height: 240px;
    width: auto;
    @media (max-width: 1050px) {
      margin-bottom: 37px;
    }
  }
  .good-content {
    width: 670px;
    max-width: 75%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (max-width: 1050px) {
      align-items: center;
      width: 100%;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: 1050px) {
      text-align: center;
    }
  }

  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
